import pawsPrint from './photos/pawsPrint.png';
import dogWalker from './photos/dogWalker.png';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { setHours, setMinutes, format } from 'date-fns';
import emailjs from '@emailjs/browser';
import SuccessToast from './SuccessToast';

const Content = () => {

  const [dogName, setDogName] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [selectedDateTime, setSelectedDateTime] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [showToast, setShowToast] = useState(false);
  const [bookedInfo, setBookedInfo] = useState({});
  

  // EmailJs Details
  const SERVICE_ID = "service_jb4r3g9";
  const TEMPLATE_ID = "template_tag70qe";
  const PUBLIC_KEY = "NDii6skJa6LvwqfZs";

  // Function that sents the data that was writen in the form to EmailJS
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!dogName.trim()) {
      alert("Please enter your dog's name 🐶");
      return;
    }

    if (!selectedDateTime) {
      alert("Please pick a date and time");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email.trim())) {
        alert("Please double-check your email — we need it to send your confirmation!");
        return;
        }

    setIsLoading(true);

    const templateParams = {
      dog_name: dogName,
      address: address,
      email: email,
      scheduled_time: format(selectedDateTime, 'MMMM d, yyyy - h:mm aa'),
    };

    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
      .then(() => {
        setBookedInfo({
            dogName: dogName,
            email: email,
        })

        setShowToast(true);
        setDogName('');
        setAddress('');
        setEmail('');
        setSelectedDateTime(null);
      })
      .catch((err) => {
        console.error(err);
        alert("Please double check you email and try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };


  

  // Function to filter out unavailable times in the DatePicker ///////////////////////////////////////////////////
  const filterTime = (time) => {
  const day = time.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  const hours = time.getHours();
  const minutes = time.getMinutes();

  // Monday to Friday (1-5)
  if (day >= 1 && day <= 5) {
    // Block 7:30 AM to 5:00 PM on weekdays
    if (hours > 7 || (hours === 7 && minutes >= 30)) {
      if (hours < 17 || (hours === 17 && minutes === 0)) {
        return false; // Block this time
      }
    }
  }

  // Saturday and Sunday (0, 6)
  if (day === 6) {
    return true; // Allow all times on Saturday
  }
  if (day === 0) {
    if (hours > 4 || (hours === 4 && minutes <= 30)) {
      return false; // Block times before 4:30 AM on Sunday
    }
  }

  return true; // Allow this time
};
//////////////////////////////////////////////////////////////////////////////////////////////////////


  return (
    <div className="content-container">
      <div className="left-contentainer">
        <h2 className="content-title">Schedule Your Dog Walk Session!</h2> <br /> 
        <h3 className="sub-heading">We will send you a confirmation to your email</h3>

        <div className="dogWalkAndPaws">
          <img src={dogWalker} className="dog-walker" alt="Dog Walker" />
          <img src={pawsPrint} className="paws-print" alt="Paws Print" />
        </div>
      </div>

      <div className="right-container">
        <form onSubmit={handleSubmit} className="form">
          <div className="form-inputs">


            <input
                type="text"
                placeholder="My Dog's name is..."
                value={dogName}
                onChange={(e) => setDogName(e.target.value)}
                className="form-name"
                required
            
            />

            <input
                type="text"
                placeholder="Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className="form-address"
                required
            /> 

            <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-email"
                required
            />


            <DatePicker
              selected={selectedDateTime}
              onChange={(date) => setSelectedDateTime(date)}
              showTimeSelect
              filterTime={filterTime}
              minDate={new Date()}
              minTime={setHours(setMinutes(new Date(), 30), 4)}
              maxTime={setHours(setMinutes(new Date(), 30), 21)}
              dateFormat="MMMM d, yyyy h:mm aa"
              placeholderText="Pick your date & time"
              className="date-picker"
              showIcon
              required
            />
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : "Schedule Walk for My Dog"}
          </button>
        </form>
      </div>

            {showToast && (
            <SuccessToast
                dogName={bookedInfo.dogName}
                email={bookedInfo.email}
                onClose={() => setShowToast(false)}
            />
            )}


    </div>
  );
};

export default Content;